/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const CH_AVAILABILITY_BOOKING = 'permitAvailabilityGridBooking';
export const CH_PERMIT_VENUE_BOOKING = 'permitVenueBooking';
export const CH_COMMERCIAL_ALLOCATION_BOOKING = 'permitCommercialAllocationBooking';

export const CH_LOTTERY_REGISTRATION = 'permitLotteryRegistration';
